import Common from '@/utils/common.js';
import {
    CACHE_KEY, 
    CACHE_EXPIRE
} from '@/type/mutation';
import {
    gameInfosNew
} from '@/api/gameInfosApi';

/**
 * 获取全部游戏数据：本地缓存优先，无则请求接口并写入缓存
 * @param {boolean} forceRefresh - 是否强制刷新缓存
 * @returns {Promise<Array>} 游戏数组
 */
export async function fetchAllGamesCached(forceRefresh = true) {
    // 如果强制刷新，先清除缓存
    if (forceRefresh) {
        Common.removeCache(CACHE_KEY);
    }
    
    const _cachedData = Common.getCache(CACHE_KEY, CACHE_EXPIRE);
    
    // Return Datas By LocalStorage
    if(_cachedData && Array.isArray(_cachedData) && _cachedData.length > 0)
    {
        // console.log('=== gameDataLoader_js__fetchAllGamesCached__by__cache >>>', _cachedData);
        return _cachedData;
    }

    // Return Datas By Axios-Post
    const _res = await gameInfosNew();
    if(_res && _res.errCode === 0)
    {
        const _data = _res.data || [];
        // console.log('=== gameDataLoader_js__fetchAllGamesCached__by__query >>>', _data);
        Common.setCache(CACHE_KEY, _data);
        return _data;
    }

    throw new Error(_res?.errMsg || 'fetchAllGamesCached: Unknown error');
}

/**
 * 清除游戏数据缓存
 */
export function clearGamesCache() {
    Common.removeCache(CACHE_KEY);
}
